<template>
  <div>
    <section class="grid-flex">
      <div class="box">
        <div class="box-title flex between middle">
          <div class="flex between middle">
            Equipe (Usuários): {{ account.used_limits.users | number }} / {{ account.plan_limits.users | number }} 
            <div style="margin-left: 16px">Precisa de mais usuários? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
          </div>
          <div>
            <div class="button primary" @click="openModalCreate()"  :class="{'disable': alertLimit }" >
              NOVO
            </div>
          </div>
        </div>
        <div class="box-content">
          <div>
            <ul class="list-users">
              <li v-for="(user, index) in users" :key="index">
                <div class="flex middle">
                  <div class="flex-1">{{ user.email }}</div>
                  <div class="flex-1">
                    <div class="flex end actions">
                      <div
                        class="button secondary"
                        @click="selectUserToEdit(user)"
                      >
                        EDITAR
                      </div>
                      <div
                        class="button secondary"
                        @click="
                          selectedUserId = user.id;
                          showModalDelete = true;
                        "
                      >
                        REMOVER
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
        </div>
      </div>
    </section>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse usuário?"
      @cancel="
        showModalDelete = false;
        selectedUserId = null;
      "
      @accept="deleteUser(selectedUserId)"
    ></modal-confirm>
    <!-- modal new user / update -->
    <modal
      :title="modalTitle"
      :show="showModalCreateOrUpdate"
      @close="cleanUserModalInfo()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Nome</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newUser.name"
                autocomplete="off"
              />
            </div>

            <div class="flex-1 w100 margin-top-m">
              <label>E-Mail</label>
              <input
                class="input"
                type="text"
                id="emailUser"
                v-model="newUser.email"
                :disabled="selectedUserId"
                :readonly="selectedUserId"
                autocomplete="off"
              />
            </div>
            <div class="flex-1 w100 margin-top-m">
              <label v-if="!selectedUserId">Senha</label>
              <label v-else>Nova Senha</label>
              <input
                class="input"
                id="newPassword"
                type="password"
                v-model="newUser.password"
                autocomplete="off"
              />
            </div>
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrUpdateUser()">CRIAR</div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

import {
  listUser,
  createUser,
  updateUser,
  deleteUser,
} from "@/services/manager";

export default {
  name: "config-user",
  components: {
    Modal,
    ModalConfirm,
  },
  data() {
    return {
      loading: false,
      users: [],
      selectedUserId: null,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      newUser: {
        name: "",
        email: "",
        password: "",
      },
    };
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    modalTitle() {
      return this.selectedUserId ? "Editar Usuário" : "Criar Usuário";
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.users <= this.account.used_limits.users) {
        return true
      }

      return false
    },
  },
  methods: {
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de Usuários do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreateOrUpdate = true
    },
    selectUserToEdit(user) {
      this.selectedUserId = user.id;
      this.newUser = this.$ObjectCopy(user);
      this.showModalCreateOrUpdate = true;
    },
    cleanUserModalInfo() {
      this.selectedUserId = null;
      this.showModalCreateOrUpdate = false;
      this.newUser = {
        name: "",
        email: "",
        password: "",
      };
    },
    saveOrUpdateUser() {
      if (this.selectedUserId) {
        this.updateUser(this.selectedUserId);
      } else {
        this.createUser();
      }

      this.cleanUserModalInfo();
    },
    checkResource(name) {
      return this.account && this.account.resources.includes(name);
    },
    getUsers() {
      this.loading = true;

      listUser()
        .then((result) => {
          this.users = result;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao buscar usuários",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createUser() {
      let params = {
        name: this.newUser.name,
        email: this.newUser.email,
        password: this.newUser.password,
      };

      createUser(params)
        .then((result) => {
          this.users.push(result);

          this.$toast.success({
            title: "Sucesso",
            message: "Usuário criado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao criar usuário",
          });
        });
    },
    updateUser(user_id) {
      let params = {
        name: this.newUser.name,
        email: this.newUser.email,
        password: this.newUser.password,
      };

      updateUser(user_id, params)
        .then((result) => {
          let auxFind = this.users.find((e) => e.id === user_id);
          auxFind.name = result.name;

          this.$toast.success({
            title: "Sucesso",
            message: "Usuário atualizado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao criar usuário",
          });
        });
    },
    deleteUser(user_id) {
      if (user_id == this.user.id) {
        this.$toast.error({
          title: "Erro",
          message: "Você não pode remover seu proprio usuário",
        });

        this.showModalDelete = false;
        return;
      }
      deleteUser(user_id)
        .then(() => {
          this.users = this.users.filter((u) => u.id != user_id);

          this.$toast.success({
            title: "Sucesso",
            message: "Usuário deletado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Falha ao deletar usuário",
          });
        })
        .finally(() => {
          this.showModalDelete = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.list-users {
  li {
    list-style-type: none;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #c2c2c258;
  }
}

.actions {
  > div {
    margin-left: 4px;
  }
}
</style>
